var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
import { createInertiaApp, router } from '@inertiajs/vue3';
import { createApp, h } from 'vue';
import PrimeVue from 'primevue/config';
import PrimeVueDS from 'cInterface/primevue.config';
import Tooltip from 'primevue/tooltip';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import { createPinia } from 'pinia';
import { addToHistory, clearHistory } from 'common/utils/history';
import ApplicationWrapper from 'common/vue/Components/ApplicationWrapper.vue';
var THEME_STYLE_ID = 'inertia-theme-vars';
function applyTheme(colourTheme) {
    var style = document.getElementById(THEME_STYLE_ID);
    if (!style) {
        style = document.createElement('style');
        style.id = THEME_STYLE_ID;
        style.type = 'text/css';
        document.head.appendChild(style);
    }
    style.textContent = colourTheme ? ":root { ".concat(colourTheme, " }") : '';
}
var appName = ((_a = window.document.getElementsByTagName('title')[0]) === null || _a === void 0 ? void 0 : _a.innerText) || '';
var weightMap = {
    300: 'Light',
    400: 'Regular',
    500: 'Medium',
    600: 'SemiBold',
    700: 'Bold',
};
createInertiaApp({
    title: function (title) { return [title, appName].filter(Boolean).join(' | '); },
    resolve: function (name) { return import("./Pages/".concat(name, ".vue")); },
    setup: function (_a) {
        var _b;
        var el = _a.el, App = _a.App, props = _a.props, plugin = _a.plugin;
        clearHistory();
        try {
            var dataPage = el && 'dataset' in el ? el.dataset.page : undefined;
            var initial = typeof dataPage === 'string' ? JSON.parse(dataPage) : null;
            applyTheme((_b = initial === null || initial === void 0 ? void 0 : initial.props) === null || _b === void 0 ? void 0 : _b.colourTheme);
        }
        catch (_c) {
            // ignore invalid initial page
        }
        var baseUrl = window.baseUrl || '';
        var css = Object.entries(weightMap)
            .map(function (_a) {
            var _b = __read(_a, 2), weight = _b[0], name = _b[1];
            return "\n                @font-face {\n                  font-family: 'Inter';\n                  src: url('".concat(baseUrl, "/modules/?file=Inter/Inter-").concat(name, ".woff2&fontsPath=1') format('woff2');\n                  font-weight: ").concat(weight, ";\n                  font-style: normal;\n                  font-display: swap;\n                }\n              ");
        })
            .join('\n');
        var style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(css));
        document.head.appendChild(style);
        var app = createApp({
            render: function () {
                return h(ApplicationWrapper, {}, {
                    default: function () { return h(App, props); },
                });
            },
        })
            .use(plugin)
            .use(PrimeVue, { unstyled: true, pt: PrimeVueDS })
            .use(ToastService)
            .use(ConfirmationService)
            .directive('tooltip', Tooltip)
            .use(createPinia());
        app.mount(el);
    },
    progress: {
        color: '#0093dd',
    },
});
function onPageChanged(page) {
    applyTheme(page.props.colourTheme);
    var generatedLinks = page.props.generatedLinks;
    if (generatedLinks && Object.keys(generatedLinks).length) {
        window.generatedLinks = generatedLinks;
    }
    addToHistory(page.url);
}
router.on('navigate', function (e) { return onPageChanged(e.detail.page); });
router.on('success', function (e) { return onPageChanged(e.detail.page); });
